import { render, staticRenderFns } from "./technique.vue?vue&type=template&id=3a82cc98&"
import script from "./technique.vue?vue&type=script&lang=js&"
export * from "./technique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a82cc98')) {
      api.createRecord('3a82cc98', component.options)
    } else {
      api.reload('3a82cc98', component.options)
    }
    module.hot.accept("./technique.vue?vue&type=template&id=3a82cc98&", function () {
      api.rerender('3a82cc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/technique.vue"
export default component.exports